import { Link } from "react-router-dom";

/**
 * Approved GP monogram + wordmark rendered as hand-drawn inline SVG.
 * Single-colour gold (#C6A659) on transparent. Interlocked G and P share
 * a central vertical. No coloured container, no ring, no dual-tone.
 *
 * `theme` — "gold" (default) for use on navy backgrounds, "inverse" for
 *          white variant when placed on very warm/bright surfaces.
 * `variant` — "full" (monogram + wordmark), "mark" (monogram only).
 */
export default function Logo({ theme = "gold", variant = "full", asLink = true }) {
  const stroke = theme === "inverse" ? "#FFFFFF" : "#C6A659";

  const monogram = (
    <g fill="none" stroke={stroke} strokeWidth="14" strokeLinecap="round" strokeLinejoin="round">
      <path d="M 66 26 L 32 26 A 14 14 0 0 0 18 40 L 18 70 A 14 14 0 0 0 32 84 L 66 84 L 66 56 L 48 56" />
      <path d="M 66 84 L 66 26 L 96 26 A 21 21 0 0 1 96 68 L 66 68" />
    </g>
  );

  const svg = variant === "mark" ? (
    <svg
      className="gp-logo__svg gp-logo__svg--mark"
      viewBox="0 0 130 110"
      aria-hidden="true"
      focusable="false"
      preserveAspectRatio="xMinYMid meet"
    >
      {monogram}
    </svg>
  ) : (
    <svg
      className="gp-logo__svg"
      viewBox="0 0 560 110"
      aria-hidden="true"
      focusable="false"
      preserveAspectRatio="xMinYMid meet"
    >
      {monogram}
      <g fill={stroke} fontFamily="Manrope, 'Helvetica Neue', Arial, sans-serif">
        <text x="146" y="66" fontWeight="800" fontSize="32" letterSpacing="1.6">GOLD PETROLEUM</text>
        <text x="146" y="94" fontWeight="700" fontSize="15" letterSpacing="3.2">FZ LLC</text>
      </g>
    </svg>
  );

  if (!asLink) {
    return (
      <span className="gp-logo gp-logo--static" aria-label="Gold Petroleum FZ LLC">
        {svg}
      </span>
    );
  }

  return (
    <Link
      to="/"
      className="gp-logo"
      aria-label="Gold Petroleum FZ LLC — home"
      data-testid="site-logo"
    >
      {svg}
    </Link>
  );
}
